module.exports = "<fines-reimbursements-page></fines-reimbursements-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/finesReimbursementsView.html
// module id = 2227
// module chunks = 0